import React, { useContext, useEffect, useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { Menu } from 'primereact/menu';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Avatar } from 'primereact/avatar';
import { CSSTransition } from 'react-transition-group';
//import { RTLContext } from './index';
//import { AuthContext } from './index';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AuthStateAtom, SiteIdAtom, SiteInfoAtom, AppStateAtom } from './atoms';
import { Dialog } from 'primereact/dialog';
import { getIn, useFormik } from 'formik';
import { ObixUtil } from './service/ObixUtil';
import { Toast } from 'primereact/toast';
import { Password } from 'primereact/password';

export function AppLogo(props) {
    const hstyle = {
        align: "left",
        fontStyle: "italic",
        fontSize: "2em",
        margin: 0,
        color: "DarkSeaGreen",
        textShadow: "2px 2px 2px black"
    }

    return <h1 id="app-logo" className="p-m-4" style={hstyle}>Mastermind</h1>
}

export function CommBlink ({connected, count}) {
    const prevCountRef = useRef(count);
    const [color, setColor] = useState("dimgray");

    useEffect(() => {
        if (!connected) {
            setColor("dimgray");
            return;
        }

        if (prevCountRef.current !== count) {
            setColor((prevColor) =>
                prevColor === "forestgreen" ? "greenyellow" : "forestgreen"
            );
            prevCountRef.current = count;
        }
    }, [connected, count]);

    return (
        <i className="pi pi-circle-on fs-large" style={{color: color}} />
    );
}

export function TopClock(props) {
    const siteInfo = useRecoilValue(SiteInfoAtom);
    const [time, setTime] = useState("");
    const [date, setDate] = useState("");

    useEffect(() => {
        let userLocale = navigator.languages && navigator.languages.length
                                ? navigator.languages[0]
                                : navigator.language;
        //userLocale = 'en';
        const interval = setInterval(
            () => {
                const d = new Date();
                setTime(d.toLocaleTimeString(userLocale, {timeZone: siteInfo.zoneId}));
                setDate(d.toLocaleDateString(userLocale, {timeZone: siteInfo.zoneId}));
            },
            1000
        );

        return () => {
            clearInterval(interval);
        }
    }, [siteInfo]);

    return (
        <span>
            <div style={{textAlign: "center"}}>{time}</div>
            <div style={{textAlign: "center"}} className="fs-small">{date}</div>
        </span>
    )
}

/**
 * @typedef {Object} AppTopbarProps
 * @property {boolean} connected - commblink를 위한 연결 상태
 * @property {number} received - blink를 위해 수신된 누적 횟수. 짝수냐 홀수냐에 따라 깜박임
 */
/**
 * 상단 Top Bar
 * @param {AppTopbarProps} props 
 * @returns {JSX.Element}
 */
const AppTopbar = (props) => {
    // props.connected: commblink를 위한 것
    // props.received: commblink 를 위한 것
    //const authContext = useContext(AuthContext);
    const auth = useRecoilValue(AuthStateAtom);
    const siteInfo = useRecoilValue(SiteInfoAtom);
    const [siteId, setSiteId] = useRecoilState(SiteIdAtom);
    const appState = useRecoilValue(AppStateAtom);
    const isRTL = false;
    const navigate = useNavigate();
    const [avatarLetter, setAvatarLetter] = useState("");
    const [avatarStyle, setAvatarStyle] = useState(null);
    const [siteMenuModel, setSiteMenuModel] = useState([]);
    const [siteName, setSiteName] = useState("");
    const [accountMenuModel, setAccountMenuModel] = useState([]);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [changePasswordInitial, setChangePasswordInitial] = useState({oldPwd: "", newPwd1: "", newPwd2: ""});
    const accountMenu = useRef(null);  // 로그인 메뉴
    const siteMenu = useRef(null);  // 로그인 메뉴

    const toast = useRef(null);
    const topbarRef1 = useRef(null);
    const topbarRef2 = useRef(null);
    const topbarRef3 = useRef(null);
    const topbarRef4 = useRef(null);

    // Avatar style 설정
    useEffect(() => {
        if (auth.authenticated && auth.user) {
            setAvatarLetter(auth.user.charAt(0).toUpperCase());
        } else {
            setAvatarLetter("?");
        }
        let theStyle = {};
        if (auth.isAdmin) {
            theStyle = { backgroundColor: '#9c27b0', color: '#ffffff' };
        } else if (auth.isUser) {
            theStyle = {
                backgroundColor: '#2196F3',
                color: '#ffffff'
            };
        } else if (auth.authenticated) {  // viewer
            theStyle = { backgroundColor: '#4caf4f', color: '#ffffff' };
        }
        setAvatarStyle(theStyle);

        const _accountMenuModel = [
            { label: `${auth.user} (${auth.role})`, icon: 'pi pi-check' },
            { label: "Change Password", icon: 'pi pi-key', command: showChangePasswordDialog },
            { label: "Log Out", icon: 'pi pi-sign-out', command: doLogOut }
        ];
        setAccountMenuModel(_accountMenuModel);
    }, [auth.user]);

    // Site 선택 메뉴 생성
    useEffect(() => {
        let label;
        if (siteId && props.regions) {
            label = props.regions[siteId];
        }
        if (!label) label = "<None Selected>";
        setSiteName(label);

        const mm = [];
        for (const key of Object.keys(props.regions)) {
            mm.push({
                label: props.regions[key],
                icon: 'pi pi-angle-right',
                command: () => {
                    setSiteId(key); // props.setRegion(key)
                }
            })
        }
        setSiteMenuModel(mm);
    }, [props.regions, siteId]);

    const showChangePasswordDialog = () => {
        setChangePasswordInitial({oldPwd: "", newPwd1: "", newPwd2: ""});
        formik.resetForm();
        setShowChangePassword(true);
    };

    const doChangePassword = () => {        
        formik.handleSubmit();
    }

    const ChangePasswordFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => setShowChangePassword(false)} className="p-button-text" />
            <Button label="Appy" icon="pi pi-check" type="button" onClick={doChangePassword} autoFocus />
        </div>
    );

    const formik = useFormik({
        initialValues: changePasswordInitial,
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            console.log("validate = %o", data);
            if (!data.oldPwd) {
                errors.oldPwd = "Enter old password.";
            }
            if (!data.newPwd1) {
                errors.newPwd1 = "Enter new password 1.";
            }
            if (!data.newPwd2) {
                errors.newPwd2 = "Enter new password 2";
            }
            if (data.newPwd1 !== data.newPwd2) {
                errors.newPwd2 = "The passwords you entered do not match.";
            }
            if (data.newPwd1.length < 8) {
                errors.newPwd1 = "New password should be longer than 8 letters.";
            }
            console.log("errors = %o", errors);
            return errors;
        },
        onSubmit: (data, {setErrors}) => {
            console.log("formik submit %o", data);

            const body = {
                o: 'obix',
                c: [
                    { o: "str", name: "oldPwd", val: data.oldPwd },
                    { o: "str", name: "newPwd1", val: data.newPwd1 },
                    { o: "str", name: "newPwd2", val: data.newPwd2 },
                ]
            };

            ObixUtil.invokeObix(`${appState.mmurl}/obix/about/changePwd`, body,
                resp => {
                    console.dir(resp.data);       
                    let rt = resp.data.c[0].display;
                    setShowChangePassword(false)
                    toast.current?.show({severity:'success', summary: "Successful", detail: rt, life: 3000});
                },
                err => {
                    console.error(err);
                    toast.current?.show({severity:'error', summary: 'Failed', detail: err, life: 3000});
                    //setErrors({ userId: "ID가 겹칩니다"});
                }
            );
        }
    });
    const isFormFieldInvalid = (name) => !!(getIn(formik.touched, name) && getIn(formik.errors, name));  // !! 는 truethy, falsey 값을 true, false로 정규화함. 
    const getFormErrorMessage = (name, cstyle) => {
        //console.log(`form error ${name}: ${cstyle} : ${isFormFieldInvalid(name)}`)
        return isFormFieldInvalid(name) ? <div className="w-full text-right"><small className={`p-error ${cstyle||''}`}>{getIn(formik.errors, name)}</small></div> : <></>;
    }

    const doLogOut = () => {
        window.localStorage["mm_token"] = "";
        setTimeout(() =>  window.location.href='/login', 500);  // 바로 reload하면 안되어서, timer 줌
    }

    return (
        <div className="layout-topbar shadow-4">
            <div className="layout-topbar-left">
                <button type="button" style={{ cursor: 'pointer' }} className="layout-topbar-logo p-link" onClick={() => navigate('/')}>
                    <AppLogo/>
                </button>
                <button type="button" className="layout-menu-button shadow-6 p-link" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-chevron-right"></i>
                </button>
                <button type="button" className="layout-topbar-mobile-button p-link">
                    <i className="pi pi-ellipsis-v fs-large" onClick={props.onMobileTopbarButtonClick}></i>
                </button>
            </div>
            <div className={classNames('layout-topbar-right', { 'layout-topbar-mobile-active': props.mobileTopbarActive })}>
                <div className="layout-topbar-actions-left">
                   <Button label={siteName} severity="info" className="px-4 p-button-primary"
                        onClick={(event) => siteMenu.current.toggle(event)}/>
                </div>
                <div className="layout-topbar-actions-right">
                    <ul className="layout-topbar-items">
                        <li className="layout-topbar-item mr-3">
                            <span>{siteInfo.zoneId}</span>
                        </li>
                        <li className="layout-topbar-item mr-3">
                            <TopClock/>
                        </li>
                        <li className="layout-topbar-item">
                            <CommBlink connected={props.connected} count={props.received}/>
                        </li>
                        <li className="layout-topbar-item notifications">
                            <button className="layout-topbar-action rounded-circle p-link" onClick={(event) => props.onTopbarItemClick({ originalEvent: event, item: 'notifications' })}>
                                <span className="p-overlay-badge">
                                    <i className="pi pi-bell fs-large"></i>
                                    <span className="p-badge p-badge-warning p-badge-dot"></span>
                                </span>
                            </button>

                            <CSSTransition nodeRef={topbarRef2} classNames="p-toggleable" timeout={{ enter: 1000, exit: 450 }} in={props.activeTopbarItem === 'notifications'} unmountOnExit>
                                <ul ref={topbarRef2} className="layout-topbar-action-panel shadow-6 fadeInDown">
                                    <li className="mb-3">
                                        <span className="px-3 fs-small">
                                            You have <b>4</b> new notifications
                                        </span>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="flex flex-row align-items-center">
                                            <img src="assets/demo/images/avatar/avatar-1.png" alt="" />
                                            <div className={classNames('flex flex-column', { 'ml-3': !isRTL, 'mr-3': isRTL })} style={{ flexGrow: '1' }}>
                                                <div className="flex align-items-center justify-content-between mb-1">
                                                    <span className="fs-small font-bold">Jerome Bell</span>
                                                    <small>42 mins ago</small>
                                                </div>
                                                <span className="fs-small">How to write content about your photographs?</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="flex flex-row align-items-center">
                                            <img src="assets/demo/images/avatar/avatar-2.png" alt="" />
                                            <div className={classNames('flex flex-column', { 'ml-3': !isRTL, 'mr-3': isRTL })} style={{ flexGrow: '1' }}>
                                                <div className="flex align-items-center justify-content-between mb-1">
                                                    <span className="fs-small font-bold">Cameron Williamson</span>
                                                    <small>48 mins ago</small>
                                                </div>
                                                <span className="fs-small">Start a blog to reach your creative peak.</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="flex flex-row align-items-center">
                                            <img src="assets/demo/images/avatar/avatar-3.png" alt="" />
                                            <div className={classNames('flex flex-column', { 'ml-3': !isRTL, 'mr-3': isRTL })} style={{ flexGrow: '1' }}>
                                                <div className="flex align-items-center justify-content-between mb-1">
                                                    <span className="fs-small font-bold">Anna Miles</span>
                                                    <small>1 day ago</small>
                                                </div>
                                                <span className="fs-small">Caring is the new marketing</span>
                                            </div>
                                        </div>
                                    </li>
                                    <li className="layout-topbar-action-item">
                                        <div className="flex flex-row align-items-center">
                                            <img src="assets/demo/images/avatar/avatar-4.png" alt="" />
                                            <div className={classNames('flex flex-column', { 'ml-3': !isRTL, 'mr-3': isRTL })} style={{ flexGrow: '1' }}>
                                                <div className="flex align-items-center justify-content-between mb-1">
                                                    <span className="fs-small font-bold">Arlene Mccoy</span>
                                                    <small>4 day ago</small>
                                                </div>
                                                <span className="fs-small">Starting your traveling blog with Vasco.</span>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                            </CSSTransition>
                        </li>
                        <li className="layout-topbar-item">
                            <Avatar label={avatarLetter} className="mr-4" size="large" shape="circle" style={avatarStyle}
                                onClick={(event) => accountMenu.current.toggle(event)}/>
                        </li>
                    </ul>
                </div>
            </div>
            <Menu model={accountMenuModel} popup ref={accountMenu} id="myMenu"/>
            <Menu model={siteMenuModel} popup ref={siteMenu} id="siteMenu" style={{width: "300px"}}/>
            <Dialog header="Change Password" visible={showChangePassword} style={{width: "30rem"}} footer={ChangePasswordFooter} onHide={() => setShowChangePassword(false)}>
                <form onSubmit={formik.handleSubmit} onReset={formik.handleReset}>
                    <div className="flex align-items-center">
                        <label htmlFor="oldPwd" className="mt-3 w-4">Old Password</label>
                        <span className="mt-3 flex-grow-1">
                            <Password id="oldPwd" value={formik.values.oldPwd} onChange={(e) => formik.setFieldValue("oldPwd", e.target.value)}
                                className={classNames("w-full", {'p-invalid': isFormFieldInvalid("oldPwd")})} toggleMask={true} feedback={false} />
                        </span>                        
                    </div>
                    {getFormErrorMessage('oldPwd')}
                    <div className="flex align-items-center">
                        <label htmlFor="newPwd1" className="mt-3 w-4">New Password 1</label>
                        <span className="mt-3 flex-grow-1">
                            <Password id="newPwd1" value={formik.values.newPwd1} onChange={(e) => formik.setFieldValue("newPwd1", e.target.value)}
                                className={classNames("w-full", {'p-invalid': isFormFieldInvalid("newPwd1")})} toggleMask={true} feedback={false} />
                        </span>                        
                    </div>
                    {getFormErrorMessage('newPwd1')}
                    <div className="flex align-items-center">
                        <label htmlFor="newPwd2" className="mt-3 w-4">New Password 2</label>
                        <span className="mt-3 flex-grow-1">
                            <Password id="newPwd2" value={formik.values.newPwd2} onChange={(e) => formik.setFieldValue("newPwd2", e.target.value)}
                                className={classNames("w-full", {'p-invalid': isFormFieldInvalid("newPwd2")})} toggleMask={true} feedback={false} />
                        </span>                        
                    </div>
                    {getFormErrorMessage('newPwd2')}
                </form>
            </Dialog>
            <Toast ref={toast} />
        </div>
    );
};

export default AppTopbar;
